import get_param from '../param'
import isFunction from 'lodash/isFunction'

export function url_without_ticket(url) {
  if (!url) {
    url = window.location.href;
  }
  return url.replace(/ticket=[^&#]*/g, '')
}

export function share_url(url) {
  console.log("url_without_ticket",url )
  let t = url_without_ticket(url);
  console.log("url_without_ticket",t )
  let res = t.replace(/code=[^&#]*/g, '');
  console.log("url_without_ticket",res )
  if (!res.includes('#')) {
    res = res + '#/'
  }
  console.log(res)
  return res
}

function get_h5_ticket(cb) {
  let ticket = null;
  if (!gact.test_env) {
    if (window.location.host === 'club.mgtv.com') {
      //1.正式环境下不取ticket参数以免ticket被分享出去导致混乱　2._ticket是调试用
      ticket = window.localStorage.getItem('usercenter_t') || get_param('_ticket')
    } else {
      ticket = get_param('ticket')
    }
  } else {
    ticket = get_param('ticket')
  }
  cb(ticket)
}

function get_app_ticket(cb) {
  if (gact.debug) {
    get_h5_ticket(cb);
    return;
  } else {
    MgtvApi.getUserInfo(function (user_info) {
      if (user_info && user_info.length !== 0) {
        const ticket = (JSON.parse(user_info)).ticket;
        cb(ticket);
      }else{
        cb(null);//没有登录
      }
    })
  }

}


export function get_ticket(cb) {
  if (!isFunction(cb)) {
    console.error("not callback function in get_ticket")
    return;
  }
  if (gact.is_app) {
    get_app_ticket(cb)
  } else {
    get_h5_ticket(cb)
  }
}






// WEBPACK FOOTER //
// ./src/tools/mgtv/ticket.js